<!-- jb-slider = 'jb-btn' -->

<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>This component uses the external component<a href="https://www.npmjs.com/package/ng5-slider">@ng5-slider</a></p>
<p>Which will be useful for dates or numbers ranges, or discounts shown in the portal. </p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>


<!--jb-slider Customization-->
<div class="whiteBg">
  <div class="row">
    <div class="col-6 marB15">
      <h5 class="marB25">jb-slider Customization:</h5>
      <div>
        <jb-slider [(ngModel)]="valueSlider"
                   [jbOptions]="sliderOptions"
                   [jbLabel]="compConf.hasLabel? compConf.labelText : ''"
                   [jbLabelTooltip]="compConf.hasTooltip? compConf.tooltipText : ''"
                   [jbLabelTooltipPos]="compConf.tooltipPos || 'top'"
                   [jbDisabled]="compConf.isDisabled">
        </jb-slider>
      </div>
      <div>
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>
      <!--<div>
        <div class="pad15 padT20">
          <pre>{{sliderOptionsCode}}</pre>
        </div>
      </div>-->
    </div>

    <div class="col-6">
      <div class="row marT15">
        <div class="col-12"><h5>Slider Option:</h5></div>
<!--        <div class="col-6" style="align-self: center;"><jb-checkbox [(ngModel)]="compConf.addSecondValue" (ngModelChange)="upComp()" jbLabel="Add Second Value"></jb-checkbox></div>-->
        <div class="col-6">
          <jb-input [(ngModel)]="valueSlider" jbLabel="Number Value" jbType="number"></jb-input>
        </div>
        <div class="col-6" style="align-self: center;"> <jb-checkbox [(ngModel)]="compConf.isDisabled" (ngModelChange)="upComp()" jbLabel="Is Disabled"></jb-checkbox> </div>

        <!--<div class="col-6"></div>
        <div class="col-6">
          <jb-input [(ngModel)]="valueSliderHigh" *ngIf="compConf.addSecondValue" jbLabel="Second Value" jbType="number"></jb-input>
        </div>-->
      </div>

      <!--<div class="row marT15">
        <div class="col-4 padT5"> <jb-checkbox [(ngModel)]="compConf.isRequired" (ngModelChange)="upComp()" jbLabel="Is Required"></jb-checkbox> </div>
        <div class="col-6 padT5"> <jb-checkbox [(ngModel)]="compConf.showOuterSection" [jbDisabled]="!compConf.addSecondValue" (ngModelChange)="upComp()" jbLabel="Show outer section"></jb-checkbox> </div>
      </div>-->

      <div class="row marT15">
        <div class="col-12"><h5>Label Options:</h5></div>
        <div class="col-4 padT5"> <jb-checkbox [(ngModel)]="compConf.hasLabel" (ngModelChange)="upComp()" jbLabel="Has Label"></jb-checkbox> </div>
        <div class="col-8" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="compConf.labelText" (ngModelChange)="upComp()" [jbDisabled]="!compConf.hasLabel"></jb-input> </div>
      </div>

      <div class="row marT10">
        <div class="col-6 padT5"> <jb-checkbox [(ngModel)]="compConf.hasTooltip" [jbDisabled]="!compConf.hasLabel" (ngModelChange)="upComp()" jbLabel="Has Tooltip"></jb-checkbox> </div>
        <div class="col-6" *ngIf="compConf.hasTooltip">
          <jb-input [(ngModel)]="compConf.tooltipText" (ngModelChange)="upComp()"></jb-input>
        </div>
        <div class="col-6" *ngIf="compConf.hasTooltip"></div>
        <div class="col-6" *ngIf="compConf.hasTooltip">
          jbLabelTooltipPos: <jb-dropdown [(ngModel)]="compConf.tooltipPos" (ngModelChange)="upComp()"
                                     [jbList]="[{ id: 'top', text: 'top' }, { id: 'right', text: 'right' }, { id: 'bottom', text: 'bottom' }, { id: 'left', text: 'left' }]"
                                     jbRender="text" jbSelect="id"> </jb-dropdown>
        </div>
      </div>

      <!--<div class="row marT15">
        <div class="col-12"><h5>Options Object:</h5></div>
        <div class="col-6"><jb-checkbox [(ngModel)]="sliderOptions.showTicks" (ngModelChange)="upComp()" jbLabel="Show Ticks"></jb-checkbox></div>
      </div>-->

    </div>

  </div>
</div>

<hr>




<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">
  
  <div class="row">
    <div class="col-5">
      <jb-slider [(ngModel)]="slider1" jbLabel="Test 1" [jbOptions]="slider1Options"></jb-slider>
    </div>
    <div class="col-5">
      <pre>{{instance}}</pre>

    </div>
    <div class="col-2">
      <pre style="font-size: 12px;">{{instance1Obj}}</pre>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <jb-slider [(ngModel)]="slider2" [jbOptions]="slider2Options"></jb-slider>
    </div>
    <div class="col-5"> <pre>{{instance2}}</pre> </div>
    <div class="col-2">
      <pre style="font-size: 12px;">{{instance2Obj}}</pre>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <jb-slider [(ngModel)]="slider3" [jbOptions]="slider3Options"></jb-slider>
    </div>
    <div class="col-5"> <pre>{{instance3}}</pre> </div>
    <div class="col-2">
      <pre style="font-size: 12px;">{{instance3Obj}}</pre>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <jb-slider [(ngModel)]="slider4" [jbOptions]="slider4Options" [jbCustomSliderLabel]="newTranslate"></jb-slider>
    </div>
    <div class="col-5"> <pre>{{instance4}}</pre> </div>
    <div class="col-2">
      <pre style="font-size: 12px;">{{instance4Obj}}</pre>
    </div>
  </div>

  <!--<div class="row">
    <div class="col-5">
      <jb-slider [(ngModel)]="slider5" [(jbHighValue)]="slider5High" [jbOptions]="slider5Options" [jbTranslate]="translate2"></jb-slider>
    </div>
    <div class="col-5"> <pre>{{instance5}}</pre> </div>
    <div class="col-2">
      <pre style="font-size: 12px;">{{instance5Obj}}</pre>
    </div>
  </div>-->

</div>



<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The encapsulated styles of the button use a default color. However, we may want to apply different colors externally (depending on the theme)
      <br/>
      To provide a color restyiling based on a SCSS theme you can apply the following rules on a css global level :
    </p>
    <pre>{{ cssReset }}</pre>
  </div>
</div>

